import { render, staticRenderFns } from "./ListModal.vue?vue&type=template&id=3188836a&"
import script from "./ListModal.vue?vue&type=script&lang=js&"
export * from "./ListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports